var EBadgeElements = /* @__PURE__ */ ((EBadgeElements2) => {
  EBadgeElements2["ROOT"] = "ROOT";
  return EBadgeElements2;
})(EBadgeElements || {});
var EBadgePlacement = /* @__PURE__ */ ((EBadgePlacement2) => {
  EBadgePlacement2["DEFAULT"] = "default";
  EBadgePlacement2["CORNER"] = "corner";
  return EBadgePlacement2;
})(EBadgePlacement || {});
export { EBadgeElements, EBadgePlacement };
